// extracted by mini-css-extract-plugin
export default {"axisLabel":"axisLabel_axisLabel__ggey+"};